import React, { useState, useEffect, useCallback } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createDrawerNavigator, DrawerContentScrollView, DrawerItem } from '@react-navigation/drawer';
import { View, ActivityIndicator, StyleSheet, Text, TouchableOpacity, Linking } from 'react-native';
import * as SplashScreen from 'expo-splash-screen';
import LoginScreen from '../screens/LoginScreen';
import AiChat from '../screens/AiChat';
import Profile from '../screens/Profile';
import Horoscope from '../screens/Horroscope';
import CreateProfile from '../screens/Createprofile';
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { useNavigation } from '@react-navigation/native';

const Stack = createStackNavigator();
const Tab = createBottomTabNavigator();
const Drawer = createDrawerNavigator();

const CustomCenterButton = ({ onPress }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={styles.centerButton}
    >
      <FontAwesome name="commenting-o" size={20} color="black" />
      <Text style={styles.centerButtonText}>Ai Astrology</Text>
    </TouchableOpacity>
  );
};

const CustomDrawerContent = (props) => {
  return (
    <DrawerContentScrollView {...props}>
      <DrawerItem
        label="Contact Us"
        onPress={() => Linking.openURL('https://astro247.in/contact')}
      />
      <DrawerItem
        label="Terms and Conditions"
        onPress={() => Linking.openURL('https://astro247.in/terms_and_conditions')}
      />
    </DrawerContentScrollView>
  );
};

const AppNavigator = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isFirsttime, setIsFirstTime] = useState(true);
  const [appIsReady, setAppIsReady] = useState(false);
  const { getItem } = useLocalStorage();

  const checkAuthStatus = async () => {
    const isUserLoggedIn = await getItem("user");
    if (isUserLoggedIn) {
      const authToken = JSON.parse(isUserLoggedIn).authToken;
      const firstTime = JSON.parse(isUserLoggedIn).firstTime;
      console.log(firstTime,'firstTimefirstTime out')
      if (!firstTime) {
        console.log(firstTime,'firstTimefirstTime')
        setIsFirstTime(false);
      }
      setIsAuthenticated(authToken && authToken.length > 0);
    } else {
      setIsAuthenticated(false);
    }
  };

  const onLayoutRootView = useCallback(async () => {
    if (appIsReady) {
      await SplashScreen.hideAsync();
    }
  }, [appIsReady]);

  useEffect(() => {
    async function prepare() {
      try {
        await SplashScreen.preventAutoHideAsync();
        await checkAuthStatus();
        await new Promise(resolve => setTimeout(resolve, 2000));
      } catch (e) {
        console.warn(e);
      } finally {
        setAppIsReady(true);
      }
    }
    prepare();
  }, []);


  useEffect(() => {
    onLayoutRootView();
  }, [onLayoutRootView]);

  

  if (!appIsReady) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" />
      </View>
    );
  }

  return (
    <>
      {isAuthenticated ? (
        <Drawer.Navigator
          initialRouteName={isFirsttime ? 'CreateProfileDrawer' : 'HomeDrawer'}
          drawerContent={(props) => <CustomDrawerContent {...props} />}
          drawerPosition="left"
          screenOptions={{drawerPosition:'right',headerShown:false,drawerStyle:{right:0, width:'80%'}}}
        >
          <Drawer.Screen
            name="HomeDrawer"
            component={TabNavigator}
            options={{ headerShown: false, drawerItemStyle: { display: 'none' } }}
          />
          <Drawer.Screen
            name="CreateProfileDrawer"
            component={CreateProfile}
            options={{ headerShown: false, drawerItemStyle: { display: 'none' } }}
          />
        </Drawer.Navigator>
      ) : (
        <Stack.Navigator initialRouteName="Login">
          <Stack.Screen
            name="Login"
            component={(props) => (
              <LoginScreen {...props} setIsAuthenticated={setIsAuthenticated} />
            )}
            options={{ headerShown: false }}
          />
        </Stack.Navigator>
      )}
    </>
  );
};

const TabNavigator = () => {
  const navigation = useNavigation();
  
  
  return (
    <Tab.Navigator screenOptions={{ headerShown: false, tabBarStyle: styles.tabBarStyle }} initialRouteName='AiChat'>
      <Tab.Screen
        name="Horoscope"
        component={Horoscope}
        options={{
          title: "Horroscope",
          tabBarIcon: ({ color, focused }) => (
            <MaterialCommunityIcons
              name={focused ? "zodiac-cancer" : "zodiac-cancer"}
              color={focused ? "#f0df21" : "#c8cccd"}
              size={22}
            />
          ),
          tabBarLabel: ({ focused }) => (
            <Text
              style={[
                styles.tabBarLabel,
                { color: focused ? "#f0df21" : "#c8cccd" },
              ]}
            >
              Horroscope
            </Text>
          ),
        }}
      />
      <Tab.Screen
        name="AiChat"
        component={AiChat}
        options={{
          title: "Chat",
          tabBarIcon: ({ color, focused }) => (
            <FontAwesome
              name={focused ? "commenting-o" : "commenting-o"}
              color={focused ? "#f0df21" : "#c8cccd"}
              size={22}
            />
          ),
          tabBarLabel: ({ focused }) => (
            <Text
              style={[
                styles.tabBarLabel,
                { color: focused ? "#f0df21" : "#c8cccd" },
              ]}
            >
              Chat
            </Text>
          ),
        }}
      />
      <Tab.Screen
        name="Profile"
        component={Profile}
        options={{
          title: "Profile",
          tabBarIcon: ({ color, focused }) => (
            <MaterialIcons
              name={focused ? "person" : "person"}
              color={focused ? "#f0df21" : "#c8cccd"}
              size={22}
            />
          ),
          tabBarLabel: ({ focused }) => (
            <Text
              style={[
                styles.tabBarLabel,
                { color: focused ? "#f0df21" : "#c8cccd" },
              ]}
            >
              Profile
            </Text>
          ),
        }}
      />
    </Tab.Navigator>
  );
};

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  tabBarStyle: {
    height: 70,
    paddingBottom: 10,
    paddingTop: 10,
  },
  tabBarLabel: {
    fontSize: 12,
    marginTop: -5,
  },
  centerButton: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 2,
    borderRadius: 50,
    paddingHorizontal: 12,
    borderColor: "#c8cccd",
    borderWidth: 1,
    backgroundColor: "#f0df21",
  },
  centerButtonText: {
    color: "#000",
    marginLeft: 5,
  },
});

export default AppNavigator;
